import { Image, Text, VStack } from '@frontend/components';

import { IMAGES } from '../const';

export const SupportBanner = () => {
  return (
    <VStack
      width="100%"
      p={3}
      backgroundColor="brand.secondary"
      backgroundImage={IMAGES.background}
      backgroundPosition="-25% center"
      backgroundSize="55%"
      backgroundRepeat="no-repeat"
    >
      <Image
        src={IMAGES.supportTeam}
        alt="The friendly faces of the Paperless Parts support team."
        maxWidth={30}
      />
      <Text size="lg" fontWeight="heavy" color="feature.onInteraction">
        We usually respond within the hour
      </Text>
    </VStack>
  );
};
